import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue";
import _imports_0 from '../assets/tip.png';
const _hoisted_1 = {
    key: 0,
    class: "simplePage"
};
const _hoisted_2 = {
    key: 0,
    class: "well"
};
const _hoisted_3 = { class: "anchor-bottom" };
import { ref, getCurrentInstance, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useApi } from '@/composables/useApi';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SetPinPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { signalV1 } = useApi();
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const pin = ref(null);
        const pin2 = ref(null);
        const validationText = ref(null);
        const text = ref("Please set a 4 digit PIN to secure your account:");
        function setPin() {
            validationText.value = null;
            if (!/^\d{4}$/.test(pin.value || '')) {
                validationText.value = 'PIN must be a 4 digit number';
                return;
            }
            if (pin2.value != pin.value) {
                pin2.value = pin.value;
                pin.value = null;
                text.value = "Please re-enter your PIN:";
                return;
            }
            if (cookies?.get('user') === 'test@mock.com') {
                router.push({ path: '/enablenotifications' });
                return;
            }
            signalV1('setPin', pin.value, cookies?.get('user'), cookies?.get('pass'), 'enablenotifications');
        }
        onMounted(() => {
            getCustomer();
        });
        return (_ctx, _cache) => {
            const _component_v_otp_input = _resolveComponent("v-otp-input");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    bgcolor: "#00000000",
                    border: "0"
                }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Set Pin", -1)),
                                _cache[2] || (_cache[2] = _createElementVNode("img", {
                                    class: "heroImg",
                                    src: _imports_0
                                }, null, -1)),
                                _createElementVNode("p", null, _toDisplayString(text.value), 1),
                                _createVNode(_component_v_otp_input, {
                                    class: "pinField",
                                    modelValue: pin.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((pin).value = $event)),
                                    length: "4",
                                    type: "number",
                                    maxlength: "4",
                                    variant: "solo",
                                    flat: true,
                                    "single-line": "",
                                    "bg-color": "#ffffffaa"
                                }, null, 8, ["modelValue"]),
                                (validationText.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                        _createElementVNode("p", null, _toDisplayString(validationText.value), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_3, [
                                    _createVNode(MGButton, {
                                        text: "Set PIN",
                                        alt: true,
                                        onClick: setPin,
                                        arrow: true
                                    })
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
